import React from "react";

const Tooltip = ({ children, message }) => {
  return (
    <div className="relative inline-block group">
      <span tabIndex={0} aria-describedby="tooltip-message" className="focus:outline-none">
        {children}
      </span>
      <div
        id="tooltip-message"
        role="tooltip"
        className="absolute z-[100] left-1/2 -translate-x-1/2 bottom-full mb-2 min-w-[200px] max-w-[320px] w-max px-4 py-3 text-sm text-white leading-relaxed rounded-lg shadow-xl opacity-0 pointer-events-none transition-opacity duration-200 ease-in-out bg-gray-800 group-hover:opacity-100 group-hover:pointer-events-auto group-focus-within:opacity-100 group-focus-within:pointer-events-auto before:content-[''] before:absolute before:left-1/2 before:-translate-x-1/2 before:top-full before:border-[6px] before:border-transparent before:border-t-gray-800"
      >
        {message}
      </div>
    </div>
  );
};

export default Tooltip;